import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { API_URLS } from '../../../shared/constants/api-urls.constants';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DemographicService {
  urlToken: string = '';
  constructor(private http: HttpClient) { }

  getSchoolList(): Observable<any> {
    return this.http.get(`${environment.providerApiUrl}${API_URLS.GET_SCHOOLS}`)
  }
  getSpecialityList(): Observable<any> {
    return this.http.get(`${environment.credentialGetApiUrl}${API_URLS.GET_SPECIALITY}`)
  }

  saveDemographics(payload:any): Observable<any> {
    return this.http.post(`${environment.credentialGetApiUrl}${API_URLS.SAVE_DEMOGRAPHICS}`, payload)
  }

}